import styled from 'styled-components';
import MoveToGov from '../korUploadFile/MoveToGov';
import Section from './Section';
import IMG_GUIDE_GOV_1 from '@/assets/korUploadFile/img_guide_gov_1.png';
import IMG_GUIDE_GOV_2 from '@/assets/korUploadFile/img_guide_gov_2.png';
import IMG_GUIDE_GOV_5 from '@/assets/korUploadFile/img_guide_gov_5.png';
import AnnounceText from './AnnounceText';
import ExplainDetailGov from './ExplainDetailGov';

type Props = {
  onClick: () => void;
};

const GovGuide = ({ onClick }: Props) => {
  return (
    <Wrapper>
      <AnnounceText onClick={onClick} />
      <div>
        <Section
          step='step 1'
          title='정부24 사이트 접속 후 로그인'
          contents={
            <MoveToGov
              onClick={() =>
                window.open('https://www.gov.kr/portal/main/nologin', '_blank')
              }
            />
          }
        />
      </div>
      <Section
        step='step 2'
        title={
          <>
            검색창에 <Strong>'출입국에 관한 사실증명'</Strong> 입력 후 클릭
          </>
        }
        imgSrc={IMG_GUIDE_GOV_1}
      />
      <Section
        step='step 3'
        title='안내에 따라 정부 24 어플리케이션 실행'
        imgSrc={IMG_GUIDE_GOV_2}
      />
      <Section
        step='step 4'
        title='본인인증 및 발급신청'
        contents={<ExplainDetailGov />}
      />
      <Section
        step='step 5'
        title='내 정보 → 나의 신청 내역 → 전자문서지갑 → 출입국 사실증명서 저장'
        imgSrc={IMG_GUIDE_GOV_5}
      />
      <div>
        <Section
          step='step 6'
          title='업로드 하러가기를 눌러 저장된 파일 업로드'
        />
        <Text>(PDF, 캡처본 모두 업로드 가능합니다.)</Text>
      </div>
    </Wrapper>
  );
};
export default GovGuide;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  padding: 16px 0 40px;
`;

const Text = styled.p`
  color: var(--KTP-Warning-100, #ed0828);
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const Strong = styled.strong`
  color: var(--KTP-Blue-100, #246cf6);
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.4px;
`;
